import React from 'react';
import { NavLink, useSearchParams } from 'react-router-dom';

const teamMembers = [
    {
        image: require('./../../images/our-team4/pic1.png'),
        membername: 'Safder Hussain',
        position: 'CEO',
        description: 'With 15+ years of executive leadership, Safder drives our company vision and strategic growth initiatives with exceptional expertise',
        socialLinks: {
            facebook: 'https://facebook.com/safder',
            twitter: 'https://twitter.com/safder',
            instagram: 'https://instagram.com/safder',
            whatsapp: 'https://wa.me/923001234567',
            youtube: 'https://youtube.com/c/safder',
            linkedin: 'https://linkedin.com/in/safder'
        }
    },
    {
        image: require('./../../images/our-team4/pic2.png'),
        membername: 'Muhammed M. Bilal Yasir',
        position: 'Founder',
        description: 'A visionary entrepreneur with 12 years of industry innovation, Bilal built our company from the ground up with sustainable business models',
        socialLinks: {
            facebook: 'https://www.facebook.com/buildcoassociates?_rdc=2&_rdr#',
            twitter: 'https://twitter.com/bilal',
            instagram: 'https://www.instagram.com/buildcoassociates/',
            whatsapp: 'https://wa.me/923138777888',
            youtube: 'https://youtube.com/c/bilal',
            linkedin: 'https://www.linkedin.com/in/m-bilal-yasir-2511a4118/?originalSubdomain=pk'
        }
    },
    {
        image: require('./../../images/our-team4/pic3.png'),
        membername: 'Mohammad Saleem Jilani ',
        position: 'Director Projects',
        description: 'He brings substantial industry experience in manufacturing, oil field, and construction, leveraged fully throughout all related project work ',
        socialLinks: {
            facebook: 'https://facebook.com/jillani',
            twitter: 'https://twitter.com/jillani',
            instagram: 'https://instagram.com/jillani',
            whatsapp: 'https://wa.me/923001234569',
            youtube: 'https://youtube.com/c/jillani',
            linkedin: 'https://linkedin.com/in/jillani'
        }
    },
    {
        image: require('./../../images/our-team4/pic4.png'),
        membername: 'Rooh Ul Husnain',
        position: 'HR Manager',
        description: 'Highly experienced HR professional with 2 years of expertise. Skilled in talent acquisition, employee engagement, and HR strategies',
        socialLinks: {
            facebook: 'https://www.facebook.com/share/1CsMDgKqrw/',
            twitter: 'https://x.com/faizanzafar437',
            instagram: 'https://www.instagram.com/faizanawan35?igsh=NnZvemc3bXQ0dDVv',
            whatsapp: 'https://wa.me/message/U2TB6YGP4D3EI1',
            youtube: 'https://youtube.com/c/faizan',
            linkedin: 'https://linkedin.com/in/faizan'
        }
    },
    {
        image: require('./../../images/our-team4/pic5.png'),
        membername: 'Malik Rehnaz Akhtar',
        position: 'Site Incharge',
        description: 'Experienced Site Incharge with 15 years of expertise. Skilled in construction management, quality control, and team leadership.',
        socialLinks: {
            facebook: 'https://www.facebook.com/share/17ZacNicHB/',
            twitter: 'https://twitter.com/usman',
            instagram: 'https://www.instagram.com/usman_manzoor4?igsh=MXhwOWdsbWJwZms2bQ==',
            whatsapp: 'https://wa.me/923421717604',
            youtube: 'https://youtube.com/c/usman',
            linkedin: 'https://www.linkedin.com/in/usman-manzoor-6371b7282/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app'
        }
    },
    {
        image: require('./../../images/our-team4/pic6.png'),
        membername: 'Wajiha Zaffer',
        position: 'Admin Officer',
        description: 'He brings 10 years of operational expertise, ensuring smooth administrative processes and organizational efficiency',
        socialLinks: {
            facebook: 'https://www.facebook.com/share/16gnYy4AMq/',
            twitter: 'https://x.com/wasif4455',
            instagram: 'https://www.instagram.com/wasif_butt_01?igsh=bWp1ZmtmdmdoOGl0   ',
            whatsapp: 'https://wa.me/923365143711',
            youtube: 'https://youtube.com/@wasifbutt-n6d?si=TxvF6gXl19M0gxwH',
            linkedin: 'https://www.linkedin.com/in/wasif-butt-2a420b358'
        }
    },
    {
        image: require('./../../images/our-team4/pic7.png'),
        membername: 'Muhammad Wasif Butt',
        position: 'IT Administrator',
        description: 'Manages and maintains the organization’s IT infrastructure, ensures system security, provides technicalsupport',
        socialLinks: {
            facebook: 'https://www.facebook.com/share/16gnYy4AMq/',
            twitter: 'https://x.com/wasif4455',
            instagram: 'https://www.instagram.com/wasif_butt_01?igsh=bWp1ZmtmdmdoOGl0   ',
            whatsapp: 'https://wa.me/923365143711',
            youtube: 'https://youtube.com/@wasifbutt-n6d?si=TxvF6gXl19M0gxwH',
            linkedin: 'https://www.linkedin.com/in/wasif-butt-2a420b358'
        }
    },
    {
        image: require('./../../images/our-team4/pic8.png'),
        membername: 'Usman Manzoor',
        position: 'Billing Officer/Audit',
        description: 'He handle billing and invoicing for our construction projects, ensuring timely payments and accurate financial records',
        socialLinks: {
            facebook: 'https://www.facebook.com/share/17ZacNicHB/',
            twitter: 'https://twitter.com/usman',
            instagram: 'https://www.instagram.com/usman_manzoor4?igsh=MXhwOWdsbWJwZms2bQ==',
            whatsapp: 'https://wa.me/923421717604',
            youtube: 'https://youtube.com/c/usman',
            linkedin: 'https://www.linkedin.com/in/usman-manzoor-6371b7282/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app'
        }
    },
    {
        image: require('./../../images/our-team4/pic9.png'),
        membername: 'Junaid Hayder Turk',
        position: 'Construction Technologist',
        description: 'He handles software and digital tools for our construction projects, ensuring seamless field-to-office communication and accurate project data',
        socialLinks: {
            facebook: 'https://www.facebook.com/share/17ZacNicHB/',
            twitter: 'https://twitter.com/usman',
            instagram: 'https://www.instagram.com/usman_manzoor4?igsh=MXhwOWdsbWJwZms2bQ==',
            whatsapp: 'https://wa.me/923421717604',
            youtube: 'https://youtube.com/c/usman',
            linkedin: 'https://www.linkedin.com/in/usman-manzoor-6371b7282/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app'
        }
    }
]

const Team3 = () => {
    const [searchParams] = useSearchParams();
    let page = parseInt(searchParams.get('page') || '1', 10);
    if (isNaN(page) || page < 1) {
        page = 1;
    } else if (page > 2) {
        page = 2;
    }

    // Page 1: first 6 team members (indices 0 to 5)
    // Page 2: remaining 2 team members (indices 6 to 7)
    const startIndex = (page - 1) * 6;
    const displayedMembers = teamMembers.slice(startIndex, startIndex + 6);

    return (
        <>
            <div className="section-full p-t80 p-b50 bg-white inner-page-padding">
                <div className="container">
                    {/* TITLE START */}
                    <div className="section-head">
                        <div className="mt-separator-outer separator-left">
                            <div className="mt-separator">
                                <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Our</span> Team</h2>
                            </div>
                        </div>
                    </div>
                    {/* TITLE END */}
                    {/* IMAGE Team START */}
                    <div className="section-content">
                        <div className="row">
                            {displayedMembers.map((item, index) => (
                                <div key={index} className="col-md-4 col-sm-6 col-xs-6 col-xs-100pc m-b30">
                                    <div className="our-team-1 hover-animation-1">
                                        <div className="profile-image scale-in-center">
                                            <img src={item.image} alt={item.membername} />
                                        </div>
                                        <div className="figcaption">
                                            <h4>{item.membername}</h4>
                                            <h5>{item.position}</h5>
                                            <p>{item.description}</p>
                                            <div className="icons">
                                                {/* Team Member Detail buttons*/}
                                                {/* <div className="mt-box">
                                                    <div className="mt-thum-bx  img-center-icon  mt-img-overlay2">
                                                        <img src={item.thumb} alt="" />
                                                        <div className="overlay-bx">
                                                            <div className="overlay-icon">
                                                                <NavLink to={"/TeamDetail1"}>
                                                                    <i className="fa fa-external-link mt-icon-box-xs " />
                                                                </NavLink>
                                                                <a className="mfp-link" href={item.image}>
                                                                    <i className="fa fa-arrows-alt mt-icon-box-xs" />
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                {/* Team Member Detail buttons */}

                                                <NavLink to={item.socialLinks.facebook} target="_blank" rel="noopener noreferrer">
                                                    <i className="fa fa-facebook" />
                                                </NavLink>
                                                <NavLink to={item.socialLinks.twitter} target="_blank" rel="noopener noreferrer">
                                                    <i className="fa fa-twitter" />
                                                </NavLink>
                                                <NavLink to={item.socialLinks.instagram} target="_blank" rel="noopener noreferrer">
                                                    <i className="fa fa-instagram" />
                                                </NavLink>
                                                <NavLink to={item.socialLinks.whatsapp} target="_blank" rel="noopener noreferrer">
                                                    <i className="fa fa-whatsapp" />
                                                </NavLink>
                                                <NavLink to={item.socialLinks.youtube} target="_blank" rel="noopener noreferrer">
                                                    <i className="fa fa-youtube" />
                                                </NavLink>
                                                <NavLink to={item.socialLinks.linkedin} target="_blank" rel="noopener noreferrer">
                                                    <i className="fa fa-linkedin" />
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <ul className="pagination m-tb0">
                        <li className={page === 1 ? 'disabled' : ''}>
                            <NavLink to={page === 1 ? '#' : '/about?page=1'}>«</NavLink>
                        </li>
                        <li className={page === 1 ? 'active' : ''}>
                            <NavLink to="/about?page=1">1</NavLink>
                        </li>
                        <li className={page === 2 ? 'active' : ''}>
                            <NavLink to="/about?page=2">2</NavLink>
                        </li>
                        <li className={page === 2 ? 'disabled' : ''}>
                            <NavLink to={page === 2 ? '#' : '/about?page=2'}>»</NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default Team3;